import MxInputChip, { MxInputChipProps } from "@rf-l1/form/text-fields/MxInputChip";
import { useMxFieldControllerContext } from "../../../../context/MxFieldController";

export type MxFormChipInputFieldProps = Omit<MxInputChipProps, "name">

const MxFormChipInputField = (props: MxFormChipInputFieldProps) => {
  const { onBlur, onChange, inputRef, name, value, invalid, required, id } =
    useMxFieldControllerContext();
  const handleBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
    if (props.onBlur) {
      props.onBlur(evt);
    }
    onBlur(evt);
  };

  return (
    <MxInputChip
      {...props}
      inputRef={inputRef}
      onChange={onChange}
      onBlur={handleBlur}
      name={name}
      value={value}
      error={invalid}
      required={required}
      id={id}
    />
  );
};

export default MxFormChipInputField;
